import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { TIMEOUT_MODAL_STATUS, SESSION_EXPIRATION } from '../actions/constants';
const INITIAL_STATE = {
  modalIsOpen: false,
  expirationTime: localStorage.expiration
};
export default function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case TIMEOUT_MODAL_STATUS:
      return _objectSpread({}, state, {
        modalIsOpen: action.payload
      });
    case SESSION_EXPIRATION:
      return _objectSpread({}, state, {
        expirationTime: action.payload
      });
    default:
      return state;
  }
}